import { IGetEnterprisesUseCase } from "../../../presentation/useCases/read/get_enterprises_use_case";
import { Enterprise } from "../../models/enterprise";
import { IAuthRepository } from "../../repositories/auth_repository";

/**
 * GetEnterprisesUseCase
 */

export class GetEnterprisesUseCase implements IGetEnterprisesUseCase {
  constructor(
    private readonly repository: IAuthRepository,
  ) { }

  async getEnterprises(): Promise<Enterprise[]> {
    return await this.repository.getEnterprises();
  }
}